import moment from "moment";
export function transformTime({
    startTime = 'startTime',
    endTime = 'endTime',
    startTimeNUmber,
    endTimeNUmber,
}) {


    if (!startTimeNUmber || !endTimeNUmber) {
        return {
            [startTime]: '',
            [endTime]: '',
        }
    }
    //     date.setHours(0, 0, 0, 0); // 参数依次是小时、分钟、秒、毫秒  
    let MinTime = new Date(new Date(startTimeNUmber).setHours(0, 0, 0, 0)).getTime(); // 开始时间 00点0分0秒
    // let MaxTime = new Date(endTimeNUmber).getTime() + 24 * 60 * 60 * 1000 - 1;// 结束时间：23点59分59秒
    let MaxTime = new Date(new Date(endTimeNUmber).setHours(23, 59, 59, 999)).getTime();// 结束时间：23点59分59秒

    let res = moment(MinTime).format("YYYY-MM-DD HH:mm:ss");
    let res1 = moment(MaxTime).format("YYYY-MM-DD HH:mm:ss");
    console.log('res', res);
    console.log('res1', res1);

    return {
        [startTime]: MinTime,
        [endTime]: MaxTime,
    }



}